export const LOSANT_RED = '#FF495C'
